export const AFFILIATES_SCHEMA = {
  en: {
    how_it_works: {
      title: "How It Works",
      steps: [
        {
          icon: "/images/icons/apply_light_blue.svg",
          title: "CREATE ACCOUNT",
          description:
            "Apply, get approved and step into your dashboard. Everything you need to start is already there.",
        },
        {
          icon: "/images/icons/promote_light_blue.svg",
          title: "PROMOTE",
          description:
            "Share Plaintr in a way that fits your voice, your content, or your business.",
        },
        {
          icon: "/images/icons/earn_light_blue.svg",
          title: "EARN",
          description:
            "As your network takes action, your earnings build. Fully tracked. Fully visible.",
        },
      ],
    },
    faq: {
      heading: "Your Questions Answered",
      cta: "View All",
      toggle_alt: {
        open: "Open",
        close: "Close",
      },
      items: [
        {
          title: "What counts as a conversion, and how much do I earn?",
          description:
            "A conversion happens when someone from your network completes a meaningful action through your link — such as using a service or engaging with Plaintr. Earnings vary depending on the type of service and activity. In some cases, you earn a percentage of revenue generated through your referrals, while other models may reward account growth or engagement. Everything is tracked inside your dashboard, so you always know what’s working and how your earnings are building over time.",
        },
        {
          title: "Do I need to sell directly?",
          description:
            "No. This is about influence, not pressure. You connect people to something valuable — the system handles the rest.",
        },
        {
          title: "Who is this program for?",
          description:
            "It is built for creators, professionals, businesses, and communities with an audience or network.",
        },
        {
          title: "Can I track my performance?",
          description:
            "Yes. You will have full visibility into activity, performance, and earnings.",
        },
        {
          title: "Is this limited to one type of service?",
          description:
            "No. The program is designed to support multiple services within the Plaintr platform.",
        },
      ],
    },
    closing_page: {
      heading: "Start building income from what you already have",
      description:
        "Your audience. Your network. Your influence. Plaintr turns it into something measurable.",
      image_alt: "Join the Affiliate Program",
      ctas: [
        { text: "Join the Affiliate Program", link: "/sign-up" },
        { text: "Log In", link: "/sign-in" },
      ],
    },
  },
};
